var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Top-Down_Icon",
    "data-name": "Top-Down Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.786,
    height: 10.583,
    viewBox: "0 0 8.786 10.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_up",
    "data-name": "Arrow up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_",
    "data-name": "Path ",
    d: "M2.17,3.583H0L2.17,0l2.17,3.583Z",
    fill: "#464767"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(1.748 3.039)",
    fill: "#464767",
    stroke: "#464767",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.42,
    height: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.42,
    height: 6,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_down",
    "data-name": "Arrow down",
    transform: "translate(4.447 0.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path ",
    d: "M2.17-3.583H0L2.17,0l2.17-3.583Z",
    transform: "translate(0 10.544)",
    fill: "#464767"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    transform: "translate(1.56)",
    fill: "#464767"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.9197809100151062 6.5 L 0.5000008940696716 6.5 L 0.5000008940696716 0.5 L 0.9197809100151062 0.5 L 0.9197809100151062 6.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.5367431640625e-07 0 L 1.419780850410461 0 L 1.419780850410461 7 L 9.5367431640625e-07 7 L 9.5367431640625e-07 0 Z",
    stroke: "none",
    fill: "#464767"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopDown);
export default __webpack_public_path__ + "static/media/top_down.fb39395c1b69e28afee115346a54ee89.svg";
export { ForwardRef as ReactComponent };